import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { connect } from 'react-redux'
import { PrivilegedRoute, Login } from '../components'
import Main from './Main'

const App = (props) => {
  const { location, auth, dispatch } = props
  return <div>
    <div style={{ width: '100%', 'backgroundColor': 'blue' }}><h1>Sou a NAVBAR</h1></div>
    <Switch>
      <Route exact path='/' render={(props) => <Login {...props} location={location} authenticate={() => dispatch({
        type: 'TOGGLE_AUTH',
        value: true
      })} />} />
      <PrivilegedRoute path='/' location={location} authenticated={auth.auth1.isAuthenticated}
        component={Main} />
    </Switch>
  </div>
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    user: state.user
  }
}

export default connect(mapStateToProps)(App)



// WEBPACK FOOTER //
// ./src/containers/App.js